export default {
  newConference: 'Nuova conferenza',
  dialInNumber: 'Numero con accesso esterno',
  host: 'Moderatore',
  participants: 'Partecipanti',
  internationalParticipants: 'Partecipanti internazionali',
  internationalNumbersHeader: 'Seleziona numeri con accesso esterno internazionali',
  search: 'Cerca...',
  inviteWithText: 'Invita con testo',
  inviteText: 'Partecipa alla conferenza RingCentral. \n\nNumeri con accesso esterno: {dialInNumber} \n\n{internationals} \nAccesso partecipante: {participantCode} \n\nServe un numero con accesso esterno internazionale? Visita http://www.ringcentral.com/conferencing \n\nQuesta conferenza telefonica è offerta dal Servizio di conferenza RingCentral.',
};
